import { render, staticRenderFns } from "./CheckBox.vue?vue&type=template&id=08c7a0c5&scoped=true"
import script from "./CheckBox.vue?vue&type=script&lang=ts"
export * from "./CheckBox.vue?vue&type=script&lang=ts"
import style0 from "./CheckBox.vue?vue&type=style&index=0&id=08c7a0c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c7a0c5",
  null
  
)

export default component.exports